import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CalendarCheck } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToTop } from "@/lib/scroll";

export default function ThankYou() {
    useEffect(() => {
        // Conversion page: keep it out of search results so only real
        // bookings land here organically.
        let meta = document.querySelector('meta[name="robots"]');
        const created = !meta;
        if (created) {
            meta = document.createElement("meta");
            meta.name = "robots";
            document.head.appendChild(meta);
        }
        const previous = meta.content;
        meta.content = "noindex, nofollow";
        return () => {
            if (created) {
                meta.remove();
            } else {
                meta.content = previous;
            }
        };
    }, []);

    return (
        <div className="grain min-h-screen bg-ink-900 text-white flex flex-col">
            <header className="border-b border-white/10">
                <div className="shell flex items-center justify-between h-16 md:h-20">
                    <Logo
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToTop();
                        }}
                    />
                    <Link
                        to="/"
                        data-testid="thank-you-back-to-site"
                        className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"
                    >
                        <ArrowLeft className="h-4 w-4" /> Back to site
                    </Link>
                </div>
            </header>
            <main className="shell flex-1 flex items-center py-24 md:py-32">
                <div
                    className="max-w-2xl mx-auto text-center"
                    data-testid="thank-you-page"
                >
                    <span className="inline-flex items-center justify-center h-16 w-16 border border-brass-500/50 rounded-full">
                        <CalendarCheck
                            className="h-7 w-7 text-brass-400"
                            aria-hidden="true"
                        />
                    </span>
                    <p className="eyebrow mt-8">Booking Confirmed</p>
                    <h1 className="mt-5 font-serif font-medium text-4xl md:text-5xl tracking-tight leading-[1.12] text-white">
                        Thank you. Your meeting is booked.
                    </h1>
                    <p className="mt-7 text-base lg:text-lg leading-relaxed text-zinc-400">
                        A calendar invitation is on its way to your inbox.
                        Ahead of the call, we will review your firm's current
                        search presence and advertising so the time is used
                        well.
                    </p>
                    <Link
                        to="/"
                        data-testid="thank-you-back-home"
                        className="btn-outline mt-11"
                    >
                        <ArrowLeft className="h-4 w-4" /> Back to homepage
                    </Link>
                </div>
            </main>
            <footer className="border-t border-white/10">
                <div className="shell py-8">
                    <p className="text-xs text-zinc-600">
                        © 2026 Scalehaus. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    );
}
